var path = 'areas/tenants/views/tenant_summary.html';
var html = "<a class=\"octo-list-group-item tenant-tile\" href=\"#/tenants/{{ ::tenant.Id }}\"> <div class=octo-list-group-item-icon> <tenant-logo tenant=::tenant max-size=60px></tenant-logo> </div> <tenant-status-popover tenant=::tenant projects-by-id=::projectsById environments-by-id=::environmentsById></tenant-status-popover> <h4 class=octo-list-group-item-heading>{{ ::tenant.Name }}</h4> <div class=tenant-tags> <tenant-tag ng-model=::tag ng-repeat=\"tag in ::tenant.TenantTags\" mode=swatch></tenant-tag> </div> </a>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/tenants/views/tenant_summary.html
// module id = 2024345194211511
// module chunks = 1